// Legacy code, just modularized

import $ from 'jquery';

const mailtoLinks = {
  init: function() {
    $('span[data-local-part]').each(function() {
      var span = $(this);
      var domain = span.text().split(/@|\(at\)/)[1];
      var email = span.attr('data-local-part') + '@' + domain;
      var emailAsText = span.attr('data-local-part') + '&shy;@' + domain;
      var link = $('<a></a>').attr('href','mailto:' + email).html(emailAsText);
      $(span).replaceWith(link);
    });

    $('span[data-local-part-nolink]').each(function() {
      var span = $(this);
      var domain = span.text().split(/@|\(at\)/)[1];
      var emailAsText = span.attr('data-local-part-nolink') + '&shy;@' + domain;
      $(span).replaceWith(emailAsText);
    });
  }
};

export default mailtoLinks;
